export default __webpack_public_path__ + "static/media/freedom.9bbb1790.png";